// components/SessionWrapper.tsx
'use client'

import { AuthProvider } from '@/lib/auth/auth-context'

export default function SessionWrapper({ children }: { children: React.ReactNode }) {
  return <AuthProvider>{children}</AuthProvider>
}
